import { Row, Col, List, Card, Empty, Button } from "antd";
import Title from "antd/es/typography/Title";
import dayjs from "dayjs";
import React, { useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import PageHeaderAstena from "../../Components/PageHeaderAstena";
import { BCServicePlanning } from "../../Interfaces/BCServicePlanning";
import { Service } from "../../Interfaces/Service";
import { DataService } from "../../Services/DataService";
import PlanningDetailSkeleton from "./Components/PlanningDetailSkeleton";
import RouteLinks from "../../Router/RouteLinks";
import { useAppSelector } from "../../Redux/hooks";
import { store } from "../../Redux/store";
import { setSelectedOrder } from "../../Redux/Slices/appSlice";

type OrderParams = {
    orderId: string;
}

const PlanningMain = () => {

    let navigate = useNavigate();
    let params = useParams<OrderParams>();
    let defaultOrder = useAppSelector(state => state.app.selectedOrder);

    const [plans, setPlans] = useState<Service<BCServicePlanning[]>>({ status: "loading" });

    React.useEffect(() => {
        if (plans.status != "loaded" || params.orderId == null) {
            DataService.getServicePlanning().then(res => {
                setPlans(res);
                if (res.status === "loaded") {
                    if (res.payload.length > 0 && params.orderId == null) {
                        console.log("selected", defaultOrder);
                        if (defaultOrder) {
                            navigate(defaultOrder);
                            store.dispatch(setSelectedOrder(null));
                        } else {
                            navigate(res.payload[0].documentNo);
                        }
                    }
                }
            }).catch(err => {
                setPlans({ status: "error", error: err })
            })
        }
    }, [params]);

    return (
        <div>
            <Row>
                <Col span={8} style={{ paddingTop: 16 }}>
                    <PageHeaderAstena
                        style={{ padding: 0, margin: 0, marginBottom: 16 }}
                        title={
                            <Title level={3} style={{ margin: 0, color: "#69ACFD" }}>
                                {`Geplande werken`}
                            </Title>
                        }
                        extra={[
                            <Button
                                key={1} type="text" style={{ color: "#EF8421", fontWeight: "600" }} disabled={plans.status === "loading"}
                                onClick={() => { navigate(`/${RouteLinks.service}/${RouteLinks.newServiceOrder}`) }}>{"+ Serviceorder toevoegen"}
                            </Button>
                        ]}
                    />
                    <List
                        locale={{
                            emptyText: <Card><Empty description="Geen planning" /></Card>
                        }}
                        pagination={{
                            pageSize: 5
                        }}
                        loading={plans.status === "loading"}
                        dataSource={plans.status == "loaded" ? plans.payload : []}
                        renderItem={(plan) => {
                            let bgcolor = (params.orderId ? (plan.documentNo == params.orderId ? "#69ACFD" : "white") : "white");
                            let color = (params.orderId ? (plan.documentNo == params.orderId ? "white" : "black") : "black");
                            let color2 = (params.orderId ? (plan.documentNo == params.orderId ? "white" : "#69ACFD") : "grey");
                            let colorNo = (params.orderId ? (plan.documentNo == params.orderId ? "white" : "#959595") : "black");
                            return (
                                <Card style={{
                                    borderRadius: 15, cursor: "pointer",
                                    background: bgcolor,
                                    color: color,
                                    marginBottom: 8,
                                    boxShadow: "rgba(149, 157, 165, 0.1) 0px 8px 24px"
                                }}
                                    onClick={() => {
                                        navigate(plan.documentNo)
                                    }}
                                >
                                    <span style={{ display: "flex", flexDirection: "column" }}>
                                        <span >{plan.serviceType}</span>
                                        <span style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span style={{ color: colorNo }}>{plan.documentNo} - {plan.jobNo}</span>
                                            <span>
                                                <span style={{ fontWeight: "bold", marginRight: 4 }}>{dayjs(plan.allocationDate).format("DD/MM/YYYY")}</span>
                                                <span style={{ fontWeight: "bold" }}>{dayjs(plan.startingTime).format("HH:mm")}</span>
                                            </span>

                                        </span>
                                        <span style={{ color: color2, fontWeight: "bold" }}>{plan.documentDescription}</span>
                                        <span style={{ marginTop: 4 }}>{plan.shipToName}</span>
                                        <span >{plan.shipToAddress}</span>
                                        <span style={{}}>{plan.shipToPostCode} {plan.shipToCity}</span>
                                    </span>

                                </Card>
                            )
                        }}
                    />
                </Col>
                <Col span={16} style={{ paddingLeft: 8 }}>
                    {params.orderId && (
                        <Outlet />
                    )}
                    {params.orderId === undefined && plans.status === "loading" && (
                        <div style={{ backgroundColor: "white" }}>
                            <PlanningDetailSkeleton />
                        </div>
                    )}
                    {params.orderId === undefined && plans.status === "loaded" && plans.payload.length <= 0 && (
                        <div style={{ backgroundColor: "white" }}>
                            <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Empty description={"Geen order geselecteerd"} />
                            </div>
                        </div>
                    )}

                </Col>
            </Row>
        </div >

    );
};

export default PlanningMain;